import React from 'react';
import { LanguageProvider } from './utils/LanguageContext';
import Navbar from './components/Navbar';
import Introduction from './components/Introduction';
import AreYouComing from './components/AreYouComing';
import SendPic from './components/SendPic';
import WhereShouldWeGo from './components/WhereShouldWeGo';
import StickySection from './components/StickySection';
import SendWish from './components/SendWish';
import './styles/index.css';
import { VersionDisplay } from 'components/VersionDisplay';

const App: React.FC = () => {
  return (
    <LanguageProvider>
      <div>
        <Navbar />
        <StickySection id="introduction">
          <Introduction />
        </StickySection>
        <StickySection id="are-you-coming">
          <AreYouComing />
        </StickySection>
        <StickySection id="where-should-we-go">
          <WhereShouldWeGo />
        </StickySection>
        <StickySection id="send-pic">
          <SendPic />
        </StickySection>
        <StickySection id="send-wish">
          <SendWish />
        </StickySection>
        <VersionDisplay version='1.1.0'/>
      </div>
    </LanguageProvider>
  );
};

export default App;